import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeletePlatformMenuItemsMutation } from "../graphql/mutations";
import type { DeletePlatformMenuItemsMutationType } from "@/types/graphql/partner.generated";

export const useDeletePlatformMenuItemsMutation = (
  options?: MutationHookOptions<DeletePlatformMenuItemsMutationType>
) => {
  return useMutation<DeletePlatformMenuItemsMutationType>(
    DeletePlatformMenuItemsMutation,
    options
  );
};
